// extracted by css-extract-rspack-plugin
module.exports =  {"item":"Item-aK6H__item"};